import VueRouter from 'vue-router';
import Vue from 'vue';
import Layout from '@/layout/index.vue';
import NullLayout from '@/layout/NullLayout.vue';
import Home from '@/views/home.vue';
import NotFind from '@/views/404.vue';
import { Lang } from '@/store/types';
import store from '@/store';
// import AgreementHome from '@/views/agreement/agreementHome.vue';

Vue.use(VueRouter);

const AgreementHome = () => import('@/views/agreement/agreementHome.vue');
const AppJurisdiction = () => import('@/views/agreement/appJurisdiction.vue');
const InformationList = () => import('@/views/agreement/informationList.vue');
const SdkList = () => import('@/views/agreement/sdkList.vue');
const HlqAgreementHome = () => import('@/views/hlqAgreement/hlqAgreementHome.vue');
const HlqInformationList = () => import('@/views/hlqAgreement/hlqInformationList.vue');
const HlqSdkList = () => import('@/views/hlqAgreement/hlqSdkList.vue');
const HlqAppJurisdiction = () => import('@/views/hlqAgreement/hlqAppJurisdiction.vue');

const MarketingSnore = () => import('@/views/marketing/snore.vue');

export const RouterNames = {
    Home: 'Home',
    Login: 'Login',
    Test: 'Test',
    NotFound: 'NotFound',
    AgreementHome: 'AgreementHome',
    AppJurisdiction: 'AppJurisdiction',
    InformationList: 'InformationList',
    SdkList: 'SdkList',
    HlqAgreementHome: 'HlqAgreementHome',
    HlqInformationList: 'HlqInformationList',
    HlqSdkList: 'HlqSdkList',
    HlqAppJurisdiction: 'HlqAppJurisdiction',
    MarketingSnore: 'MarketingSnore',
};

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/agreement/home',
        meta: {
            title: '',
        },
        // eslint-disable-next-line no-sparse-arrays
        children: [
            {
                path: '/home',
                component: Home,
                name: RouterNames.Home,
            },
            // 协议 s
            {
                path: '/agreement',
                component: NullLayout,
                children: [
                    {
                        path: 'home',
                        component: AgreementHome,
                        name: RouterNames.AgreementHome,
                    },
                    {
                        path: 'appJurisdiction',
                        component: AppJurisdiction,
                        name: RouterNames.AppJurisdiction,
                    },
                    {
                        path: 'informationList',
                        component: InformationList,
                        name: RouterNames.InformationList,
                    },
                    {
                        path: 'sdkList',
                        component: SdkList,
                        name: RouterNames.SdkList,
                    },
                ],
            },
            {
                path: '/hlqAgreement',
                component: NullLayout,
                redirect: '/hlqAgreement/home',
                children: [
                    {
                        path: 'home',
                        component: HlqAgreementHome,
                        name: RouterNames.HlqAgreementHome,
                    },
                    {
                        path: 'informationList',
                        component: HlqInformationList,
                        name: RouterNames.HlqInformationList,
                    },
                    {
                        path: 'sdkList',
                        component: HlqSdkList,
                        name: RouterNames.HlqSdkList,
                    },
                    {
                        path: 'appJurisdiction',
                        component: HlqAppJurisdiction,
                        name: RouterNames.HlqAppJurisdiction,
                    },
                ],
            },
            ,
            // 协议 e
            {
                path: '/marketing',
                component: NullLayout,
                redirect: '/marketing/snore',
                children: [
                    {
                        path: 'snore',
                        component: MarketingSnore,
                        name: RouterNames.MarketingSnore,
                    },
                ],
            },
        ],
    },
    // {
    //     path: '/test',
    //     component: TestView,
    //     name: RouterNames.Test,
    //     meta: {
    //         title: '测试页',
    //     },
    // },
    {
        path: '*',
        component: NotFind,
        name: RouterNames.NotFound,
        meta: {
            title: '404',
        },
    },
];

const router = new VueRouter({
    mode: 'hash',
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    // 优先以路径查询语言为准 s
    const lang = to.query.lang;
    if (lang && Object.values(Lang).includes(lang)) {
        store.commit('device/SetAny', { lang });
    }
    // 优先以路径查询语言为准 e
    next();
});

export default router;
